module.exports = __webpack_public_path__ + "img/about-m-slide-17.1f5ef524.jpg";